<template>
  <div class="layout">
    <div class="title-select-wrap">
      <button type="button" class="title">국민여가활동조사</button>
      <div>
        <ul class="subGnb-depth03 title-menu">
          <li><a href="javascript:;">국민여가활동조사</a></li>
          <li><a href="javascript:;">국민문화예술활동조사</a></li>
          <li><a href="javascript:;">국민독서실태조사</a></li>
          <li><a href="javascript:;">전국도서관통계</a></li>
          <li><a href="javascript:;">한국수어활용조사</a></li>
          <li><a href="javascript:;">근로자휴가조사</a></li>
          <li><a href="javascript:;">지역문화현황통계</a></li>
          <li><a href="javascript:;">국제문화교류실태조사</a></li>
          <li><a href="javascript:;">국민문화예술교육조사</a></li>
        </ul>
      </div>
    </div>
    <ul class="tab-btn-list align-start">
      <li class="on"><a href="#/" class="tab">통계표</a></li>
      <li class=""><a href="#/" class="tab">통계보고서</a></li>
      <li class=""><a href="#/" class="tab">MDSS</a></li>
      <li class=""><a href="#/" class="tab">메타정보</a></li>
    </ul>
    <div class="stat-type-wrap">
      <div class="stat-type-head align-end type02">
        <button type="button" class="default btn">목록보기</button>
        <div class="stat-search-box"><label for="searchKeyword" class="ir">검색창</label><input type="search" id="searchKeyword" /><button type="submit">검색</button></div>
        <button type="button" class="default btn mt5">명칭검색</button><button type="button" class="default btn mt5">상세검색</button>
      </div>
      <div class="stat-type-header"><h3>통계표</h3></div>
      <div>
        <div class="stat-type-content-inner">
          <div class="swiper-container swiper swiper-container-horizontal">
            <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(0px, 0px, 0px)">
              <div class="swiper-slide on swiper-slide-active" style="margin-right: 9px">
                <a href="#/">지난 1년 동안 한번이상 참여한 여가활동 유형(복수응답)-문화예술관람활동</a>
                <button type="button" class="tab-close">닫기</button>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button-disabled" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"></div>
            <div class="swiper-button-next swiper-button-disabled" tabindex="0" role="button" aria-label="Next slide" aria-disabled="true"></div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
          </div>
        </div>
        <div class="align-between stat-option">
          <h4 class="btn-area-title">지난 1년 동안 한번이상 참여한 여가활동 유형(복수응답)-문화예술관람활동</h4>
        </div>

        <!-- [start] 신규 추가 HTML 영역 -->
        <div class="btn-stat">
          <button type="button" class="default btn" @click="infoPopup($refs.infoPopup)">기본정보</button>
          <button type="button" class="default btn">합계/비율표시</button>
          <button type="button" class="default btn">행열전환</button>
          <button type="button" class="default btn mobile-hidden">피벗</button>
          <button type="button" class="default btn">화면복사</button>
          <button type="button" class="default btn mobile-hidden" @click="downLoadPopup($refs.downPopup)">다운로드</button>
          <button type="button" class="default btn" @click="openApiPopup($refs.apiPopup)">Open API</button>
          <button type="button" class="default btn">API 매뉴얼</button>
          <button type="button" class="default btn">주석</button>
          <button type="button" class="default btn bg-sky" @click="filterBox()">조회설정</button>
          <button type="button" class="default btn bg-sky" @click="statPopup($refs.statPopup)">나의 통계표</button>
          <button type="button" class="default btn bg-sky">도움말</button>
        </div>

        <div class="ibsheet-box">
          <div class="sheet-top">
            <div class="left-tab">
              <ul class="sheet-tab-menu">
                <li><a href="#n" class="tab1">통계표</a></li>
                <li><a href="#n" class="tab2" title="새창으로 열림" @click="chartPopup()">차트(새창)</a></li>
              </ul>
              <ul class="btn-temp-color">
                <li><button type="button" class="btn-temp-blue"><span class="hidden">템플릿 블루</span></button></li>
                <li><button type="button" class="btn-temp-orange"><span class="hidden">템플릿 오렌지</span></button></li>
                <li><button type="button" class="btn-temp-green"><span class="hidden">템플릿 그린</span></button></li>
              </ul>
            </div>
            <p>단위 : %, 명</p>
          </div>
          <div class="ibs-box">
            <!-- 조회설정(필터) 레이어 -->
            <div class="filter-slide-box">
              <h4>조회설정(필터)</h4>
              <button type="button" class="btn-filter-close" @click="filterBoxClose()"><span class="hidden">닫기</span></button>
              <div class="filter-list-inner">
                <div class="filter-list-box">
                  <div class="filter-tit">
                    <h5>시점(연도)</h5>
                    <button type="button" @click="filterlistToggle($event)"><span class="hidden">버튼</span></button>
                  </div>
                  <div class="check-list-box">
                    <ul>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter1-1" data-all-check="all" @change="filterCheck($event)">
                          <label for="filter1-1">전체 선택</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter1-2" @change="filterCheck($event)">
                          <label for="filter1-2">2025</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter1-3" @change="filterCheck($event)">
                          <label for="filter1-3">2024</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter1-4" @change="filterCheck($event)">
                          <label for="filter1-4">2023</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter1-5" @change="filterCheck($event)">
                          <label for="filter1-5">2022</label>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filter-list-box">
                  <div class="filter-tit">
                    <h5>표두(항목)</h5>
                    <button type="button" @click="filterlistToggle($event)"><span class="hidden">버튼</span></button>
                  </div>
                  <div class="check-list-box">
                    <ul>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter2-1" data-all-check="all" @change="filterCheck($event)">
                          <label for="filter2-1">전체 선택</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter2-2" @change="filterCheck($event)">
                          <label for="filter2-2">표본수</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter2-3" @change="filterCheck($event)">
                          <label for="filter2-3">영화관람</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter2-4" @change="filterCheck($event)">
                          <label for="filter2-4">전시회관람</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter2-5" @change="filterCheck($event)">
                          <label for="filter2-5">박물관 관람</label>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="filter-list-box">
                  <div class="filter-tit">
                    <h5>표측(통계분류)</h5>
                    <button type="button" @click="filterlistToggle($event)"><span class="hidden">버튼</span></button>
                  </div>
                  <div class="check-list-box">
                    <ul>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter3-1" data-all-check="all" @change="filterCheck($event)">
                          <label for="filter3-1">전체 선택</label>
                        </span>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter3-2" @change="filterCheck($event)">
                          <label for="filter3-2">성별</label>
                        </span>
                        <ul class="dep">
                          <li>
                            <span class="inp-box">
                              <input type="checkbox" id="filter3-2-1" @change="filterCheck($event)">
                              <label for="filter3-2-1">남자</label>
                            </span>
                          </li>
                          <li>
                            <span class="inp-box">
                              <input type="checkbox" id="filter3-2-2" @change="filterCheck($event)">
                              <label for="filter3-2-2">여자</label>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <span class="inp-box">
                          <input type="checkbox" id="filter3-3" @change="filterCheck($event)">
                          <label for="filter3-3">연령별</label>
                        </span>
                        <ul class="dep">
                          <li>
                            <span class="inp-box">
                              <input type="checkbox" id="filter3-3-1" @change="filterCheck($event)">
                              <label for="filter3-3-1">10대</label>
                            </span>
                          </li>
                          <li>
                            <span class="inp-box">
                              <input type="checkbox" id="filter3-3-2" @change="filterCheck($event)">
                              <label for="filter3-3-2">20대</label>
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="pop-btn-box align-c">
                  <button type="button" class="pop-btn w-fix bg-blue" @click="filterApply()">적용</button>
                  <button type="button" class="pop-btn w-fix line-white">초기화</button>
                </div>
              </div>
            </div>
            <!-- // 조회설정(필터) 레이어 -->

            <!-- ibsheet 영역 -->
            <div class="sheet-box">
              <div style="display: flex; height: 600px; align-items: center; justify-content: center; background: #ddd;">ibsheet 영역</div>
            </div>
            <!-- // ibsheet 영역 -->
          </div>
        </div>

        <!-- [250401] 추가 영역 -->
        <div class="stat-section">
          <h4>선택된 영역의 차트</h4>
          <div style="height: 600px; background: #ddd;">차트 들어가는 영역</div>
        </div>
        <!-- // [250401] 추가 영역 -->

        <div class="stat-section">
          <h4>공표 후 통계표 수정/보안 내역</h4>
          <div class="list-table-box">
            <table>
              <caption class="hidden">공표 후 통계표 수정/보안 내역</caption>
              <colgroup>
                <col style="width: 7%;">
                <col style="width: 15%;">
                <col>
                <col style="width: 23%;">
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>변경일시</th>
                  <th>변경사유</th>
                  <th>수정된 데이터</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center">1</td>
                  <td class="txt-center">2025.09.17 15:32</td>
                  <td>2025년 1월 15일 국가데이터처으로부터 표본수와 남녀 성별 조사 값이 틀리다는 고지를 받고 해당 내용과 값이 수정됨</td>
                  <td>: 2023년 남 표본 수 1,052 1,059</td>
                </tr>
                <tr>
                  <td class="txt-center">1</td>
                  <td class="txt-center">2025.09.17 15:32</td>
                  <td>2025년 1월 15일 국가데이터처으로부터 표본수와 남녀 성별 조사 값이 틀리다는 고지를 받고 해당 내용과 값이 수정됨</td>
                  <td>: 2023년 남 표본 수 1,052 1,059</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 기본정보 팝업 -->
        <div class="layer-popup-wrap" ref="infoPopup">
          <div class="layer-popup">
            <h4 class="pop-tit">기본정보</h4>
            <div class="pop-cont">
              <table class="pop-table">
                <caption>기본정보</caption>
                <colgroup>
                  <col class="res-col">
                  <col>
                </colgroup>
                <tbody>
                  <tr>
                    <th>통계표명</th>
                    <td>지난 1년 동안 한번이상 참여한 여가활동 유형(복수응답)-문화예술관람활동</td>
                  </tr>
                  <tr>
                    <th>목록</th>
                    <td>문화 &gt; 국민여가활동조사 &gt; 국민여가생활 실태</td>
                  </tr>
                  <tr>
                    <th>조사명</th>
                    <td>국민여가활동조사</td>
                  </tr>
                  <tr>
                    <th>입력연도</th>
                    <td>2023, 2022, 2021, 2020, 2019, 2018, 2016</td>
                  </tr>
                  <tr>
                    <th>URL</th>
                    <td>
                      <div class="copy-url">
                        <div class="txt-ell">https://stat.mcst.go.kr/portal/subject/subject01/STBL-1014</div>
                        <button type="button" class="btn-fnc">URL 복사</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="btn-pop-close" @click="popupClose($refs.infoPopup)"><span class="hidden">닫기</span></button>
          </div>
        </div>
        <!-- // 기본정보 팝업 -->

        <!-- 다운로드 팝업 -->
        <div class="layer-popup-wrap" ref="downPopup">
          <div class="layer-popup">
            <h4 class="pop-tit">다운로드</h4>
            <div class="pop-cont">
              <table class="pop-table">
                <caption>다운로드</caption>
                <colgroup>
                  <col class="res-col">
                  <col>
                </colgroup>
                <tbody>
                  <tr>
                    <th>파일형태</th>
                    <td>
                      <div class="inp-wrap">
                        <span class="inp-pop">
                          <input type="radio" name="download" id="xlsx" checked>
                          <label for="xlsx">엑셀(xlsx)</label>
                        </span>
                        <span class="inp-pop">
                          <input type="radio" name="download" id="csv">
                          <label for="csv">CSV</label>
                        </span>
                        <span class="inp-pop">
                          <input type="radio" name="download" id="txt">
                          <label for="txt">TXT</label>
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pop-btn-box align-r">
                <button type="button" class="pop-btn bg-blue">다운로드</button>
              </div>
            </div>
            <button type="button" class="btn-pop-close" @click="popupClose($refs.downPopup)"><span class="hidden">닫기</span></button>
          </div>
        </div>
        <!-- // 다운로드 팝업 -->

        <!-- 오픈API 팝업 -->
        <div class="layer-popup-wrap" ref="apiPopup">
          <div class="layer-popup">
            <h4 class="pop-tit">Open API</h4>
            <div class="pop-cont">
              <div class="agree-box">
                <h5>개인정보수집 동의</h5>
                <div class="agree-txt">
                  개인정보수집 약관 내용 영역
                </div>
                <div class="inp-wrap">
                  <span class="inp-pop">
                    <input type="radio" name="agre" id="agree-y" checked>
                    <label for="agree-y">동의합니다</label>
                  </span>
                  <span class="inp-pop">
                    <input type="radio" name="agre" id="agree-n">
                    <label for="agree-n">동의하지 않습니다</label>
                  </span>
                </div>
              </div>
              <table class="pop-table">
                <caption>Open API</caption>
                <colgroup>
                  <col class="res-col">
                  <col>
                </colgroup>
                <tbody>
                  <tr>
                    <th>데이터 포멧</th>
                    <td>JSON</td>
                  </tr>
                  <tr>
                    <th>조회기간</th>
                    <td>
                      <div class="srh-date">
                        <div class="date-box">
                          최근 시점 부터
                          <select name="" id="">
                            <option value="">년</option>
                          </select>
                        </div>
                        <div class="date-box">
                          시점
                          <select name="" id="">
                            <option value="">2023년</option>
                          </select> ~
                          <select name="" id="">
                            <option value="">2023년</option>
                          </select>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>소속</th>
                    <td><input type="text" class="inp-field" placeholder="소속을 입력해주세요."></td>
                  </tr>
                  <tr>
                    <th>사용목적</th>
                    <td><input type="text" class="inp-field" placeholder="사용목적을 간단히 입력해주세요."></td>
                  </tr>
                </tbody>
              </table>
              <div class="btn-right-box">
                <button type="button" class="btn-fnc">URL 생성</button>
              </div>
              <div class="url-area">
                <div class="url-txt">https://stat.mcst.go.kr/portal/subject/subject01/STBL-1014250?method=getList&apiKey=15456545465&itmId=13103126205T1+13103126205T2+13103126205T3+13103126205T4+13103126205T5+13103126205T6+13103126205T7+13103126205T8+13103126205T9+&objL1=ALL&objL2=&objL3=&objL4=&objL5=&objL6=&objL7=&objL8=&format=json&jsonVD=Y&prdSe=Y&newEstPrdCnt=3</div>
                <div class="pop-btn-box align-r">
                  <button type="button" class="pop-btn bg-blue">URL 복사</button>
                  <button type="button" class="pop-btn line-white">Open API 매뉴얼</button>
                </div>
              </div>
            </div>
            <button type="button" class="btn-pop-close" @click="popupClose($refs.apiPopup)"><span class="hidden">닫기</span></button>
          </div>
        </div>
        <!-- // 오픈API 팝업 -->

        <!-- 나의 통계표 팝업 -->
        <div class="layer-popup-wrap" ref="statPopup">
          <div class="layer-popup">
            <h4 class="pop-tit">나의 통계표</h4>
            <div class="pop-cont">
              <div class="info-txt">
                <ul>
                  <li>‘나의 통계표’ 기능은 고객님게서 현재 해당 통계표에 적용하신(조회조건, 피봇 등) 내역을 다음 방문때에 조회 설정 없이 이용하실 수 있도록 URL을 배포하는 부가서비스 입니다.
                  </li>
                  <li>문화셈터의 통계를 자주 활용하시는 고객은 발행되는 URL을 즐겨찾기 하신 후 활용하시는 것을 추천드립니다.</li>
                </ul>
              </div>
              <div class="url-area">
                <div class="url-txt">https://stat.mcst.go.kr/portal/subject/subject01/STBL-1014250?method=getList&apiKey=15456545465&itmId=13103126205T1+13103126205T2+13103126205T3+13103126205T4+13103126205T5+13103126205T6+13103126205T7+13103126205T8+13103126205T9+&objL1=ALL&objL2=&objL3=&objL4=&objL5=&objL6=&objL7=&objL8=&format=json&jsonVD=Y&prdSe=Y&newEstPrdCnt=3</div>
                <div class="pop-btn-box align-r">
                  <button type="button" class="pop-btn bg-blue">URL 복사</button>
                </div>
              </div>
            </div>
            <button type="button" class="btn-pop-close" @click="popupClose($refs.statPopup)"><span class="hidden">닫기</span></button>
          </div>
        </div>
        <!-- // 나의 통계표 팝업 -->

        <!-- // [end] 신규 추가 HTML 영역 -->
      </div>
    </div>
  </div>
</template>

  <script>
  import $ from 'jquery'

  export default {
      name: 'Stats',
      mounted () {
        // 아웃사이드 클릭 팝업 종료
        document.addEventListener('click', (e) => {
          if(e.target.classList.contains('layer-popup-wrap')) {
            this.popupClose(e.target)
          }
        })
      },
      methods: {
        // 조회설정 박스 열기
        filterBox() {
          document.querySelector('.filter-slide-box').classList.add('open')
        },

        // 조회설정 박스 닫기
        filterBoxClose() {
          document.querySelector('.filter-slide-box').classList.remove('open')
        },

        // 옵션 리스트 드롭다운
        filterlistToggle(evt) {
          const target = evt.target
          $(target).parents('.filter-tit').next('.check-list-box').slideToggle()
          $(target).toggleClass('close')
        },

        filterApply() {
          this.filterBoxClose()
        },

        // 옵션 체크박스 선택/해제
        filterCheck(evt) {
          const target = $(evt.target)
          if(target.parents('li').children().length === 2) { // 선택값에 하위 선택값이 있다면
            if(target.parent().next('ul') && target.prop('checked') === true) { // 하위 선택값 모두 체크
              target.parent().next().find('input[type=checkbox]').prop('checked', true)
            } else { // 하위 선택값 체크 해제
              target.parent().next().find('input[type=checkbox]').prop('checked', false)
            }
          } else if(target.parents('.dep').prev('.inp-box')[0]) {
            if(target.prop('checked') === true) {
              target.parents('.dep').prev('.inp-box').find('input[type=checkbox]').prop('checked', true)
            } else {
              let count = []
              target.parents('.dep').find('.inp-box input[type=checkbox]').each(function(index, item) {
                  count.push($(item).prop('checked'))
              })
              if(count.indexOf(true) == '-1') {
                target.parents('.dep').prev('.inp-box').find('input[type=checkbox]').prop('checked', false)
              }
            }

          } else if(target.data('all-check') === 'all') { // '전체 선택' 항목을 선택한다면
            if(target.prop('checked') === true) { // 하위 선택값 모두 체크
              target.parents('ul').find('input[type=checkbox]').prop('checked', true)
            } else { // 하위 선택값 체크 해제
              target.parents('ul').find('input[type=checkbox]').prop('checked', false)
            }
          }

        },

        // 기본정보 팝업 실행
        infoPopup(popId) {
          this.popupOpen(popId)
        },

        // 다운로드 팝업 실행
        downLoadPopup(popId) {
          this.popupOpen(popId)
        },

        // openApi 팝업 실행
        openApiPopup(popId) {
          this.popupOpen(popId)
        },

        // 나의 통계표 팝업 실행
        statPopup(popId) {
          this.popupOpen(popId)
        },

        // 팝업 열기
        popupOpen(popId) {
          popId.classList.add('open')
        },

        // 팝업 닫기
        popupClose(popId) {
          popId.classList.remove('open')
        },

        // 차트 새창으로 열기
        chartPopup() {
          window.open('/html/ChartPopup', '_blank', 'noopener, noreferrer')
        }
      }
  }
</script>

<style scoped>

</style>
